import { DateTime } from 'luxon';

export class WeeklyTotals {
    siteId?: string;
    siteDisplayName?: string;
    weekEnding?: DateTime;
    enteredBuilderRepairs?: number;
    inventoryRepairs?: number;
    totalAdjustment?: number;
}
